import { safeExecute } from "@opendaw/lib-std";
import { Box, Field } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class AudioPitchStretchBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new AudioPitchStretchBox({
            uuid,
            graph,
            name: "AudioPitchStretchBox",
            pointerRules: {
                accepts: [Pointers.AudioPlayMode],
                mandatory: true,
                exclusive: false,
            },
        }), constructor);
    }
    static ClassName = "AudioPitchStretchBox";
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitAudioPitchStretchBox, this);
    }
    get warpMarkers() {
        return this.getField(1);
    }
    initializeFields() {
        return {
            1: Field.hook({
                parent: this,
                fieldKey: 1,
                fieldName: "warpMarkers",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.WarpMarkers],
                    mandatory: true,
                    exclusive: false,
                },
            }),
        };
    }
}
